<template lang="pug">
    div
        form(
            @submit.prevent="sendEasyPayLink"
        )
            .title#easy-pay-send-form-title.pb-3 Where would you like to send this EasyLink?

            v-text-field.pt-0(
                id="easy-pay-send-form-name-input"
                v-model="name"
                label="Customer Name"
                ref="name"
                :rules="[rules.required]"
            )

            v-text-field.pt-0(
                id="easy-pay-send-form-amount-input"
                v-model="amount"
                label="Amount"
                ref="amount"
                v-money="money"
                :rules="[rules.required]"
            )
            v-textarea(
                id="easy-pay-send-form-description-input"
                v-model="description"
                outline
                ref="description"
                label="Description"
                maxlength="255"
                counter
            )

            .subheading.pb-2.text-xs-left.font-weight-light Send to
            v-radio-group.pa-0.ma-0( v-model="sendType" row :rules="[rules.required]" @change="sendTo = null")
                v-radio(
                    id="easy-pay-send-form-send-type-email-input"
                    label="Email"
                    value="Email"
                )
                v-radio(
                    id="easy-pay-send-form-send-type-phone-input"
                    label="Phone"
                    value="Phone Number"
                )

            v-text-field.pt-0(
                id="easy-pay-send-form-send-to-input"
                :label="sendType ? sendType : 'Select a send method'"
                :rules="sendType === 'Email' ? [rules.required, rules.email] : [rules.required, rules.phoneNumber]"
                :mask="sendType === 'Phone Number' ? '###-###-####' : null"
                return-masked-value
                v-model="sendTo")

            p#easy-pay-send-form-expiration-note.mt-2.caption.font-weight-bold EasyLink will expire if the recipient does not open within 24 hours.
            v-btn(
                id="easy-pay-send-form-button"
                type="submit"
                class="full-width mx-0 white--text"
                color="blue"
                :disabled="submitDisabled"
            )
                v-icon(class="mr-2") send
                | send
</template>

<script>
import envVars from '@/env_vars.js'
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        name: null,
        amount: null,
        description: null,
        money: {
            prefix: '$',
            precision: 2,
            thousands: ',',
            decimal: '.',
        },
        rules: {
            required: value => !!value || 'Required.',
            email: value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Invalid email',
            phoneNumber: value => /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/.test(value) || 'Invalid phone number'
        },
        sendTo: null,
        sendType: null,
    }),
    computed: {
        submitDisabled() {
            return !this.name || !this.amount || !this.sendType || !this.description
        },
        parsedAmount() {
            return parseFloat(this.amount.slice(1).replace(/,/g, ''))
        },
    },
    methods: {
        sendEasyPayLink() {
            console.log('Step 1, Creating paymentData Object')
            // console.log(this.amount)
            const paymentData = {
                "amount": this.parsedAmount,
                "companyName": this.$store.state.user.companyName,
                "customerName": this.name,
                "dealerId": this.$store.state.user.dealerId,
                "description": this.description,
                "path": `${envVars.c4cWebAppBaseUrl}/open-link`,
                "sendType": this.sendType,
                "sendTo": this.sendTo
            }
            console.log(paymentData)
            this.$emit('send', paymentData)
        },
    }
}
</script>

<style lang="scss" scoped>

    .v-text-field--outline::v-deep .v-input__slot {
        border: 1px solid gray !important;
    }

    .v-input::v-deep .v-input--radio-group__input {
        justify-content: space-evenly !important;
    }

</style>